export class Constants {
  static readonly TIME = 'shortTime';
  static readonly MONTH_DAY = 'MMM dd';
  static readonly DAY_MONTH_YEAR = 'dd/MM/yy';
}
